import { SearchCriteriaQualityManagement } from './../utils/SearchCriteriaQualityManagement';
import { Http, Response, URLSearchParams } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { Statique } from "../utils/statique";
import { EbQmIncident } from '../classes/ebIncident';

@Injectable()
export class QualityManagementService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  searchIncidents(searchCriteriaQM: SearchCriteriaQualityManagement) {
    return this.authHttp
      .post(Statique.controllerQualityManagement + "/listIncident", searchCriteriaQM)
      .map((res: Response) => res.json());
  }

  listCommande(searchCriteriaQM: SearchCriteriaQualityManagement){
    return this.authHttp
    .post(Statique.controllerQualityManagement + "/list-commande", searchCriteriaQM)
    .map((res: Response) => res.json());
  }

  getCommande(searchCriteriaQM: SearchCriteriaQualityManagement){
    return this.authHttp
    .post(Statique.controllerQualityManagement + "/get-commande", searchCriteriaQM)
    .map((res: Response) => res.json());
  }

  listRootCause(){
    return this.authHttp
    .get(Statique.controllerQualityManagement + "/list-root-cause")
    .map((res: Response) => res.json());
  }

  listIncidentCategory(){
    return this.authHttp
    .get(Statique.controllerQualityManagement + "/list-incident-category")
    .map((res: Response) => res.json());
  }

  saveIncident(incident:EbQmIncident){
    return this.authHttp
    .post(Statique.controllerQualityManagement + "/save-incident", incident)
    .map((res: Response) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/quality-mangement.service..ts